import { Box } from "@mui/material";

import StarterKit from "@tiptap/starter-kit";
import {
	MenuButtonBlockquote,
	MenuButtonBold,
	MenuButtonBulletedList,
	MenuButtonItalic,
	MenuButtonRedo,
	MenuButtonUnderline,
	MenuButtonUndo,
	MenuControlsContainer,
	MenuDivider,
	RichTextEditorProvider,
	RichTextField,
} from "mui-tiptap";

import { Placeholder } from "@tiptap/extension-placeholder";
import { Underline } from "@tiptap/extension-underline";
import { TextStyle } from "@tiptap/extension-text-style";
import { FontSize } from "./FontSizeExtension";

import { Editor, useEditor } from "@tiptap/react";
import { useEffect } from "react";

interface EditorProps {
	initialvalue: string | undefined;
	editableArg: boolean;
	handlerEditorUpdate: (editor: Editor) => void;
	handlerEditorFocus?: () => void;
}

const RichTextEditorComponent = (props: EditorProps) => {
	const { initialvalue, editableArg, handlerEditorUpdate, handlerEditorFocus } = props;

	const editorRichtext = useEditor({
		extensions: [
			StarterKit,
			Underline,
			Placeholder.configure({
				placeholder: "Enter your legal terms and conditions...",
			}),
			TextStyle,
			FontSize,
		],
		editable: editableArg,
		content: initialvalue,
		onUpdate: ({ editor }) => handlerEditorUpdate(editor),
		onFocus: () => {
			if (handlerEditorFocus) {
				handlerEditorFocus();
			}
		},
	});

	useEffect(() => {
		if (editorRichtext) {
			editorRichtext.commands.setContent(initialvalue ?? "");
		}
	}, [initialvalue]);

	useEffect(() => {
		if (editorRichtext) {
			editorRichtext.setEditable(editableArg);
		}
	}, [editableArg]);

	return (
		<Box
			sx={{
				"& .MuiTiptap-RichTextField-content .tiptap": {
					height: "400px",
					overflow: "auto",
					paddingRight: "20px",
					marginRight: "-30px",
					fontFamily: "PTSansProNarrow",
					color: "var(--text-color)",
					fontSize: "12px",
				},
				"& .richText-container .MuiTiptap-MenuBar-sticky": {
					borderColor: "var(--disabled-and-stroke-color) !important",
				},
				"& .richText-container:hover .MuiTiptap-FieldContainer-notchedOutline": {
					border: "1px solid var(--primary-color) !important",
				},
				"& .MuiTiptap-FieldContainer-focused .MuiTiptap-FieldContainer-notchedOutline": {
					border: "1px solid var(--primary-color) !important",
				},
			}}
		>
			<RichTextEditorProvider editor={editorRichtext}>
				<RichTextField
					className="richText-container"
					controls={
						<MenuControlsContainer>
							<MenuButtonUndo />
							<MenuButtonRedo />
							<MenuDivider />
							<MenuButtonBold />
							<MenuButtonItalic />
							<MenuButtonUnderline />
							<MenuDivider />
							<MenuButtonBlockquote />
							<MenuButtonBulletedList />
						</MenuControlsContainer>
					}
				/>
			</RichTextEditorProvider>
		</Box>
	);
};
export default RichTextEditorComponent;
